import { render, staticRenderFns } from "./BprForm.vue?vue&type=template&id=d7b81624"
import script from "./BprForm.vue?vue&type=script&lang=ts"
export * from "./BprForm.vue?vue&type=script&lang=ts"
import style0 from "./BprForm.vue?vue&type=style&index=0&id=d7b81624&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports